import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  Html5QrcodeScanner,
  Html5QrcodeScanType,
  Html5QrcodeSupportedFormats,
  Html5Qrcode, 
  Html5QrcodeCameraScanConfig
} from 'html5-qrcode';

@Component({
  selector: 'app-qr-code-scanner',
  templateUrl: './qr-code-scanner.component.html',
  styleUrls: ['./qr-code-scanner.component.scss'],
})
export class QrCodeScannerComponent implements OnInit {
  @Input() show: boolean = false;
  @Output() callback = new EventEmitter<any>(); // อีเวนต์สำหรับการเปลี่ยนหน้า

  formatsToSupport: any = [Html5QrcodeSupportedFormats.QR_CODE];
  html5Qrcode!: Html5Qrcode;

  config: any = {};
  html5QrCodeScanner: any;
  constructor() {}

  ngOnInit(): void {

    const qrCodeRegionId = 'qr-reader'; // ID ของ div ที่ใช้แสดงกล้อง
    this.html5Qrcode = new Html5Qrcode(qrCodeRegionId);

    // ตัวเลือกการสแกนกล้องหลัง
    const cameraConfig: Html5QrcodeCameraScanConfig = {
      fps: 10, // ความถี่ในการสแกน (เฟรมต่อวินาที)
      qrbox: 250, // ขนาดของกรอบสแกน
      // facingMode: 'environment', // บังคับใช้กล้องหลัง
    };

    // เริ่มการสแกนกล้อง
    this.html5Qrcode
      .start(
        { facingMode: 'environment' }, // กล้องหลัง
        cameraConfig,
        this.onScanSuccess.bind(this),
        this.onScanFailure.bind(this)
      )
      .catch((err) => {
        console.error('Unable to start scanning:', err);
        this.back();
      });



    // this.config = {
    //   fps: 10,
    //   qrbox: 250,
    //   formatsToSupport: this.formatsToSupport,
    //   facingMode: 'environment', // กล้องหลัง
    //   supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA], // กล้องอย่างเดี่ยวไม่เอาไฟล์
    // }; // กำหนดความเร็วการสแกนและขนาดของกล่องสแกน
    
    // this.html5QrCodeScanner = new Html5QrcodeScanner(
    //   'qr-reader',
    //   this.config,
    //   /* verbose= */ false
    // );
    // this.startScanner();
    // if (!this.show) {
    //   const formatsToSupport = [Html5QrcodeSupportedFormats.QR_CODE];
    //   const html5QrCodeScanner = new Html5QrcodeScanner(
    //     'qr-reader',
    //     this.config,
    //     /* verbose= */ false
    //   );
    //   html5QrCodeScanner.clear();
    // }
  }


  // ฟังก์ชันที่ทำงานเมื่อสแกนสำเร็จ
  onScanSuccess(decodedText: string, decodedResult: any) {
    this.html5Qrcode.stop(); // หยุดการสแกนหลังจากสแกนสำเร็จ
    this.callback.emit({ status: 'success', value: decodedText });
    // console.log(`Scanned result: ${decodedText}`, decodedResult);
    // alert(`Scanned Successfully: ${decodedText}`);
  }

  // ฟังก์ชันที่ทำงานเมื่อสแกนไม่สำเร็จ
  onScanFailure(errorMessage: string) {
    // this.html5Qrcode.stop(); // หยุดการสแกนหลังจากสแกนสำเร็จ
    // this.callback.emit({ status: 'close', value: '' });
    // this.html5Qrcode.clear(); // หยุดการสแกนหลังจากสแกนสำเร็จ
  }

  back() {
    this.html5Qrcode.stop(); // หยุดการสแกนหลังจากสแกนสำเร็จ
    this.callback.emit({ status: 'close', value: '' });
  }

  startScanner() {
    const qrCodeSuccessCallback = (decodedText: string, decodedResult: any) => {
      console.log(`Code matched = ${decodedText}`, decodedResult);
      // คุณสามารถดำเนินการหลังจากได้ค่า decodedText เช่นการแสดงผล หรือใช้ข้อมูลนั้นต่อไป
      this.html5QrCodeScanner.clear();
      this.callback.emit({ status: 'success', value: decodedText });
    };
    const qrCodeErrorCallback = (errorMessage: string) => {
      // console.error(`Error scanning QR code: ${errorMessage}`);
      // this.callback.emit({status: 'error', value: errorMessage});
    };

    this.html5QrCodeScanner.render(qrCodeSuccessCallback, qrCodeErrorCallback);
  }
}
